<template>
    <v-form ref="form" autocomplete="off" @submit.prevent="save" >
        <v-row>
                    <v-col cols="12" sm="6">
                        <v-text-field
                                
                                prepend-icon="business"
                                name="razonSocial"
                                v-model="form.razonSocial"
                                :label="$t('admin.company.labels.razonSocial')"
                                :placeholder="$t('admin.company.labels.razonSocial')"
                                :error="hasInputErrors('razonSocial')"
                                :error-messages="getInputErrors('razonSocial')"
                                color="secondary"
                                :rules="required"
                        ></v-text-field>
                    </v-col>
                    
                    <v-col cols="12" sm="6">
                        <v-text-field
                                
                                prepend-icon="store"
                                name="nombreFantasia"
                                v-model="form.nombreFantasia"
                                :label="$t('admin.company.labels.nombreFantasia')"
                                :placeholder="$t('admin.company.labels.nombreFantasia')"
                                :error="hasInputErrors('nombreFantasia')"
                                :error-messages="getInputErrors('nombreFantasia')"
                                color="secondary"
                        ></v-text-field>
                    </v-col>
                    <v-col cols="12">
                        <v-text-field
                                prepend-icon="mdi-map-marker"
                                name="direccion"
                                v-model="form.direccion"
                                :label="$t('admin.company.labels.direccion')"
                                :error="hasInputErrors('direccion')"
                                :error-messages="getInputErrors('direccion')"
                                color="secondary"
                        ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6">
                        <v-text-field
                                prepend-icon="mdi-phone"
                                name="telefono"
                                v-model="form.telefono"
                                :label="$t('admin.company.labels.telefono')"
                                :error="hasInputErrors('telefono')"
                                :error-messages="getInputErrors('telefono')"
                                color="secondary"
                        ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6">
                        <v-text-field
                                prepend-icon="mdi-email-outline"
                                name="emailComercial"
                                v-model="form.emailComercial"
                                :label="$t('admin.company.labels.emailComercial')"
                                placeholder="contacto@empresa.com"
                                :error="hasInputErrors('emailComercial')"
                                :error-messages="getInputErrors('emailComercial')"
                                color="secondary"
                        ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6">
                        <v-text-field
                                prepend-icon="mdi-email-lock"
                                name="emailContacto"
                                v-model="form.emailContacto"
                                :label="$t('admin.company.labels.emailContacto')"
                                placeholder="email@empresa.com"
                                :error="hasInputErrors('emailContacto')"
                                :error-messages="getInputErrors('emailContacto')"
                                color="secondary"
                                :hint="$t('admin.company.labels.emailContactoHint')"
                                persistent-hint
                        ></v-text-field>
                    </v-col>

                    <v-col cols="12" sm="6">
                        <v-select
                                prepend-icon="mdi-package-variant"
                                v-model="form.planId"
                                :items="planes"
                                item-text="nombre"
                                item-value="id"
                                label="Plan"
                                :hint="'Define los permisos iniciales de los roles de la empresa'"
                                persistent-hint
                                :loading="loadingPlanes"
                                clearable
                                color="secondary"
                        ></v-select>
                    </v-col>

                    <v-col cols="12">
                        <v-switch
                            v-model="form.envioEmailHabilitado"
                            label="Permitir envío de comprobantes por email"
                            color="primary"
                            hint="Si está desactivado, Invira no mostrará opciones de envío por correo"
                            persistent-hint
                        ></v-switch>
                    </v-col>
        </v-row>

        <!-- Configuración AFIP -->
        <v-expansion-panels class="mt-4">
            <v-expansion-panel>
                <v-expansion-panel-header>
                    <v-icon left>mdi-cog</v-icon>
                    Configuración AFIP
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                    <v-row>
                        <v-col cols="12">
                            <v-switch
                                v-model="form.afipActivo"
                                label="Activar configuración AFIP"
                                color="primary"
                            ></v-switch>
                        </v-col>

                        <v-col cols="12" md="6">
                            <v-text-field
                                name="cuit"
                                :value="form.cuit"
                                @input="onCuitInput"
                                :label="$t('admin.company.labels.cuit')"
                                :placeholder="$t('admin.company.labels.cuit')"
                                :error="hasInputErrors('cuit')"
                                :error-messages="getInputErrors('cuit')"
                                :rules="cuitRules"
                                outlined
                                dense
                            ></v-text-field>
                        </v-col>

                        <v-col cols="12" md="6">
                            <v-text-field
                                v-model="form.afipDomicilioFiscal"
                                label="Domicilio Fiscal"
                                :error="hasInputErrors('afipDomicilioFiscal')"
                                :error-messages="getInputErrors('afipDomicilioFiscal')"
                                outlined
                                dense
                            ></v-text-field>
                        </v-col>

                        <v-col cols="12" md="6">
                            <v-select
                                v-model="form.afipCondicionIVA"
                                :items="condicionesIVA"
                                label="Condición IVA"
                                :error="hasInputErrors('afipCondicionIVA')"
                                :error-messages="getInputErrors('afipCondicionIVA')"
                                outlined
                                dense
                            ></v-select>
                        </v-col>

                        <v-col cols="12" md="6">
                            <v-text-field
                                v-model="form.afipPuntoVenta"
                                label="Punto de Venta"
                                type="number"
                                :rules="[v => !v || v > 0 || 'Debe ser mayor a 0', v => !v || v <= 9999 || 'Debe ser menor o igual a 9999']"
                                :error="hasInputErrors('afipPuntoVenta')"
                                :error-messages="getInputErrors('afipPuntoVenta')"
                                outlined
                                dense
                            ></v-text-field>
                        </v-col>

                        <v-col cols="12" md="6">
                            <v-select
                                v-model="form.afipAmbiente"
                                :items="ambientes"
                                label="Ambiente"
                                :error="hasInputErrors('afipAmbiente')"
                                :error-messages="getInputErrors('afipAmbiente')"
                                outlined
                                dense
                            ></v-select>
                        </v-col>

                        <v-col cols="12">
                            <v-textarea
                                v-model="form.afipCertificadoPEM"
                                label="Certificado PEM"
                                :error="hasInputErrors('afipCertificadoPEM')"
                                :error-messages="getInputErrors('afipCertificadoPEM')"
                                outlined
                                rows="5"
                                hint="Copie aquí el contenido del archivo .crt (incluir -----BEGIN CERTIFICATE-----)"
                            ></v-textarea>
                        </v-col>

                        <v-col cols="12">
                            <v-textarea
                                v-model="form.afipClavePrivadaPEM"
                                label="Clave Privada PEM"
                                :error="hasInputErrors('afipClavePrivadaPEM')"
                                :error-messages="getInputErrors('afipClavePrivadaPEM')"
                                outlined
                                rows="5"
                                hint="Copie aquí el contenido del archivo .key (incluir -----BEGIN PRIVATE KEY-----)"
                            ></v-textarea>
                        </v-col>
                    </v-row>
                </v-expansion-panel-content>
            </v-expansion-panel>
        </v-expansion-panels>
    </v-form>
</template>

<script>

    import {InputErrorsByProps, RequiredRule } from '@dracul/common-frontend'
    import PlanProvider from '../../../providers/PlanProvider'
    import { applyCuitCuilInput, formatCuitCuilDisplay } from '../../../../../utils/cuitCuilFormat'

    export default {
        name: "CompanyForm",
        mixins: [InputErrorsByProps, RequiredRule],

        props:{
            value: {
                type: Object,
                required: true
            },
        },
        data(){
            return {
                planes: [],
                loadingPlanes: false,
                condicionesIVA: [
                    { text: 'Responsable Inscripto', value: 'RESPONSABLE_INSCRIPTO' },
                    { text: 'Monotributo', value: 'MONOTRIBUTO' },
                ],
                ambientes: [
                    { text: 'Homologación (Testing)', value: 'HOMOLOGACION' },
                    { text: 'Producción', value: 'PRODUCCION' }
                ],
                cuitRules: [
                    v => !v || /^[\d\s-]+$/.test(v) || 'El CUIT debe contener solo números y guiones',
                    v => !v || (v.replace(/\D/g, '').length === 11) || 'El CUIT debe tener exactamente 11 dígitos'
                ]
            }
        },
        created() {
            this.fetchPlanes()
            if (this.form.cuit) {
                this.form.cuit = formatCuitCuilDisplay(this.form.cuit)
            }
        },
        computed: {
           form: {
                get() { return this.value },
                set(val) {this.$emit('input', val)}
            }
        },
        watch: {
            form: {
                handler(newVal) {
                    this.$emit('input', newVal)
                },
                deep: true
            }
        },
        methods: {
            validate(){
              return this.$refs.form.validate()
            },
            onCuitInput(val) {
                this.form.cuit = applyCuitCuilInput(val)
            },
            fetchPlanes() {
                this.loadingPlanes = true
                PlanProvider.fetchPlanes()
                    .then(r => {
                        this.planes = (r.data.adminPlanFetch || []).filter(p => p.active !== false)
                    })
                    .catch(err => console.error('[CompanyForm] Error fetching planes:', err))
                    .finally(() => this.loadingPlanes = false)
            }
        }
    }
</script>

<style scoped>

</style>

